//@ts-nocheck
import { Input, type InputProps } from 'antd';
import styled from 'styled-components';

interface FormInputProps extends InputProps {
  width?: string;
  border_color?: string;
}

export const SCOPE_FORM_INPUT_CLASS = 'scope-form-input';

export const FormInput = styled(Input).attrs((props) => ({
  className: [props.className, SCOPE_FORM_INPUT_CLASS].filter(Boolean).join(' '),
}))<FormInputProps>`
  width: ${(props) => (props.width ? props.width : '90%')};
  border-radius: 0;
  border: 1px solid transparent;
  padding: ${(props) => (props.addonAfter ? '0px 0px' : '6px 11px')};
  min-width: 25%;
  height: 45px;
  border: 1px solid
    ${(props) => (props.border_color ? props.border_color : 'transparent')};
  &:hover,
  &:focus,
  &:active {
    border: 1px solid var(--color-primary, #41aaaf);
    box-shadow: none;
  }
  // .ant-select-selection-item {
  //   //background: red !important;
  // }

  .ant-input-outlined {
    border-radius: 0 !important;
    border: 1px solid transparent !important;
    width: ${(props) => (props.width ? props.width : '90%')} !important;
    height: 43px;
    padding: 0px 10px !important;
  }

  .ant-input-group {
    width: ${(props) => (props.width ? props.width : '90%')} !important;
  }

  .ant-input-group-addon {
    border-radius: 0 !important;
    border: 1px solid transparent !important;
    background: white;
  }
`;
interface FormPasswordInputProps extends InputProps {
  border_color?: string;
  lmargin?: string;
}
export const FormPasswordInput = styled(Input.Password).attrs((props) => ({
  className: [props.className, SCOPE_FORM_INPUT_CLASS].filter(Boolean).join(' '),
}))<FormPasswordInputProps>`
  width: 330px;
  border-radius: 0;
  border: 1px solid
    ${(props) => (props.border_color ? props.border_color : 'transparent')};
  padding: 6px 11px;
  height: 45px;
  margin-left: ${(props) => (props.lmargin ? props.lmargin : '0')};
  &:hover,
  &:focus,
  &:active {
    border: 1px solid var(--color-primary, #41aaaf);
    box-shadow: none;
  }
`;

export const SCOPE_ROUND_INPUT_CLASS = 'scope-round-input';

interface RoundInputProps extends InputProps {
  width?: string;
  height?: string;
  bg_color?: string;
}

export const RoundInput = styled(Input).attrs((props: RoundInputProps) => ({
  variant: props.variant ?? 'borderless',
  className: [props.className, SCOPE_ROUND_INPUT_CLASS].filter(Boolean).join(' '),
}))<RoundInputProps>`
  &&.ant-input,
  &&.ant-input-affix-wrapper,
  &&.ant-input-outlined,
  &&.ant-input-affix-wrapper-outlined {
    width: ${(props) => (props.width ? props.width : '305px')};
    height: ${(props) => (props.height ? props.height : '40px')};
    border-radius: 100px !important;
    border: 1px solid transparent !important;
    font-size: 14px;
    background: ${(props) =>
      props.bg_color
        ? props.bg_color
        : 'var(--color-surface-raised, #ffffff)'} !important;
    box-shadow: none !important;
    color: var(--color-text-base, #2e2e2e) !important;
  }

  &&.ant-input-affix-wrapper .ant-input,
  &&.ant-input-affix-wrapper .ant-input-outlined {
    border: none !important;
    border-radius: 0 !important;
    box-shadow: none !important;
    outline: none !important;
    background: transparent !important;
    color: var(--color-text-base, #2e2e2e) !important;
  }

  .ant-input-prefix,
  .ant-input-prefix .anticon {
    color: var(--color-text-muted, #5a6a6a) !important;
  }

  &::placeholder,
  &&.ant-input-affix-wrapper input::placeholder {
    color: var(--color-placeholder, #5a6a6a) !important;
  }

  &&.ant-input:hover,
  &&.ant-input:focus,
  &&.ant-input-affix-wrapper:not(.ant-input-affix-wrapper-disabled):hover,
  &&.ant-input-affix-wrapper-focused,
  &&.ant-input-affix-wrapper:focus,
  &&.ant-input-affix-wrapper:focus-within {
    border: 1px solid var(--color-primary, #41aaaf) !important;
    box-shadow: none !important;
  }

  &&.ant-input-affix-wrapper-focused .ant-input,
  &&.ant-input-affix-wrapper:focus-within .ant-input {
    border: none !important;
    box-shadow: none !important;
  }
`;

